module.exports = __webpack_public_path__ + "img/81w.9232c96.jpg";